/**
 * @generated SignedSource<<9f926782c12532b932516a26a137f4f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionButtonsEventSignUp_event$data = {
  readonly allowedGroupSizes: ReadonlyArray<number | null | undefined>;
  readonly signUpWindows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cancelDeadlineAt: string | null | undefined;
        readonly cancelDeadlineDaysAhead: number | null | undefined;
        readonly cancelDeadlineTime: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPrimaryChargeNameAndPrice_event">;
  readonly " $fragmentType": "ActionButtonsEventSignUp_event";
};
export type ActionButtonsEventSignUp_event$key = {
  readonly " $data"?: ActionButtonsEventSignUp_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionButtonsEventSignUp_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionButtonsEventSignUp_event",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPrimaryChargeNameAndPrice_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedGroupSizes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindowConnection",
      "kind": "LinkedField",
      "name": "signUpWindows",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindowEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUpWindow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cancelDeadlineAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cancelDeadlineDaysAhead",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cancelDeadlineTime",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "81deb49dafabadaa4751b93befb2fcb4";

export default node;
